module.exports = __webpack_public_path__ + "static/media/qrs_bg_device-gray.e73dceca.jpg";